import { useSubscription } from 'observable-hooks'

import { standardWebComponentProperties } from '@salsita-ai/platform-project-sdk/domain'
import {
  getDefaultConfigurationId,
  setConfigurationIdQuery,
  useOnMount,
  useWebComponentProperty$,
  useWebComponentPropertySetter,
} from '@salsita-ai/platform-project-sdk/react'

import { configuratorInterface } from '../systems/configurator-interface'

export const appWrapperElement = configuratorInterface.createOnConfiguratorReadyProvider(({ children }) => {
  const isPresetEbmedded = configuratorInterface.usePresetEmbeddedState() !== null
  const isRecipeEmbedded = configuratorInterface.useRecipeEmbeddedState() !== null
  const isEmbedded = isPresetEbmedded || isRecipeEmbedded

  const expanded$ = useWebComponentProperty$(standardWebComponentProperties.expanded)
  const setExpanded = useWebComponentPropertySetter(standardWebComponentProperties.expanded)

  useOnMount(() => {
    if (isEmbedded) {
      return
    }
    if (getDefaultConfigurationId()) {
      setExpanded(true)
    }
  })

  useSubscription(expanded$, expanded => {
    if (isEmbedded) {
      return
    }
    if (!expanded && getDefaultConfigurationId() !== null) {
      setConfigurationIdQuery(null)
    }
  })
  return <>{children}</>
})
